import React from 'react'
import SupportPrivacyPolicy from '../support-privacy-policy'

const SupportPrivacyPolicySv = () => {
    return <SupportPrivacyPolicy languageCode="sv" />
}

export default SupportPrivacyPolicySv
